import { gql } from '@apollo/client';

export const MANAGED_INTERVENTION_INSTITUTIONS = gql`
  query ManagedInterventionInstitutions($input: FilterInterventionInstitutions!) {
    institutions: filteredInterventionInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
            intervention {
              id
            }
          }
          district {
            id
            name
          }
          interventionManagers {
            id
            endDate
            isArchived
            reasonForArchiving
            role
            startDate
            institution {
              id
            }
            intervention {
              id
            }
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
